import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconicModule } from 'app/shared/components/iconic/iconic.module';
import { ListModule } from 'app/shared/components/list/list.module';
import { AttachmentsComponent } from './attachments.component';
import { LoadingPanelModule } from 'app/shared/components/loading-panel/loading-panel.module';

@NgModule({
  imports: [CommonModule, ListModule, IconicModule, LoadingPanelModule],
  declarations: [AttachmentsComponent],
  exports: [AttachmentsComponent],
})
export class AttachmentsModule {}
